module.exports = __webpack_public_path__ + "img/3x.adbd1f1.jpg";